import { generatePath } from 'react-router-dom';
import { removeWhiteSpaceURI, TransactionType, TransactionTypesOptions } from 'vopay';

// The client portal's transaction-detail route (ID-13367): one source of truth for the path so the many
// places that link to it — the shared Transaction History feature (via useTransactionsHostProps), the
// Customer Activity tab, the rail detail sub-links — don't each hand-interpolate the same string. Imported
// as `import * as transactionDetailRoute` (see the shared nav convention's `*.route.ts` shape); `path` is
// the react-router pattern for the <Route>, `getPath` builds a concrete URL. The TransactionType segment
// is stripped of spaces (removeWhiteSpaceURI) so multi-word rails stay a single path segment.
export const id = 'transactionDetail';

export const path = '/transactions-history/details/:TransactionType/:TransactionID/:Currency';

export function getPath({
  transactionType,
  transactionID,
  currency,
}: {
  // Either representation of a transaction type: the string-union (TransactionsLists.TransactionType) or the
  // TransactionType enum (LinkedTransactions.TransactionType). Both space-strip to one URL segment.
  transactionType: TransactionTypesOptions | TransactionType;
  transactionID: string;
  currency: string;
}) {
  return generatePath(path, {
    TransactionType: removeWhiteSpaceURI(transactionType),
    TransactionID: transactionID,
    Currency: currency,
  });
}
